import styled from "styled-components";

export const CardList = styled.ul`
	display: grid;
	grid-template-columns: 1fr;
	justify-content: flex-start;
	gap: ${({ theme }) => theme.spacing(4)};
	list-style: none;

	${({ theme }) => theme.breakpoints.mobile} {
		grid-template-columns: 1fr 1fr;
	}

	${({ theme }) => theme.breakpoints.tablet} {
		grid-template-columns: 1fr 1fr 1fr;
	}

	${({ theme }) => theme.breakpoints.desktop} {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
`;
